module.exports = __webpack_public_path__ + "img/light-mode-background.25a7954d.jpg";